var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-content bg-purple"},[_c('div',{staticClass:"box parentflex"},[_c('p',[_vm._v(_vm._s(_vm.ydTitle))]),_c('div',{staticClass:"count"},[_c('div',{staticClass:"pagebox"},[_c('div',{staticClass:"zline",attrs:{"id":_vm.id}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }